import { render } from "./TestCases.vue?vue&type=template&id=2fff3278"
import script from "./TestCases.vue?vue&type=script&lang=js"
export * from "./TestCases.vue?vue&type=script&lang=js"

import "./TestCases.vue?vue&type=style&index=0&id=2fff3278&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea});
